import { block3EducationMethodsConfig } from '../components/subjectBlocks/block3Components/EducationMethods';
import { subjectHistoryConfig } from '../components/subjectBlocks/block3Components/SubjectHistory';
import { languageSubjectsConfig } from '../components/subjectBlocks/block3Components/SubjectLanguage';
import { subjectMathematicsConfig } from '../components/subjectBlocks/block3Components/SubjectMathematics';
import { subjectScienceConfig } from '../components/subjectBlocks/block3Components/SubjectScience';
import { subjectsNatureConfig } from '../components/subjectBlocks/block3Components/SubjectsNature';
import { commonSubjectConfig } from '../components/subjectBlocks/block3Components/commonSubjectConfig';
import { subjects } from '../constants/subjects';

export const getSucjectMethodsConfig = (selectedSubject: string) => {
  const isLanguageSubject = [
    subjects.LT_lang,
    subjects.PL_lang,
    subjects.RU_lang,
    subjects.EN_lang,
    subjects.DE_lang,
    subjects.FR_lang,
    subjects.HE_lang,
    subjects.IT_lang,
    subjects.ES_lang,
  ].includes(selectedSubject);
  const isScienceSubject = [
    subjects.FIZ_subject,
    subjects.CHM_subject,
  ].includes(selectedSubject);
  const isMathematicsSubject = selectedSubject === subjects.MAT_subject;
  const isHistorySubject = selectedSubject === subjects.HIS_subject;
  const isNatureSubject = [
    subjects.GEO_subject,
    subjects.BIO_subject,
    subjects.GMS_subject,
  ].includes(selectedSubject);

  let subjectConfig = {};

  if (isLanguageSubject) {
    subjectConfig = languageSubjectsConfig;
  } else if (isScienceSubject) {
    subjectConfig = subjectScienceConfig;
  } else if (isMathematicsSubject) {
    subjectConfig = subjectMathematicsConfig;
  } else if (isHistorySubject) {
    subjectConfig = subjectHistoryConfig;
  } else if (isNatureSubject) {
    subjectConfig = subjectsNatureConfig;
  } else {
    subjectConfig = {};
  }

  return {
    ...block3EducationMethodsConfig,
    ...subjectConfig,
    ...commonSubjectConfig,
  };
};
